import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinsitparaindustrialarea() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Sitapura Industrial Area',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Sitapura Industrial Area ',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and efficient Corporate Cab Service in Sitapura Industrial Area, serving the travel requirements of manufacturing plants, industrial units, export houses, business parks, and corporate offices in the zone. Our fleet of well-maintained sedans, SUVs, MUVs, and premium vehicles ensures timely, safe, and comfortable transportation for employees, technicians, managers, clients, and top-level executives. Whether it is daily staff commute, shift-wise employee movement, inter-factory travel, airport transfers, industrial visits, business meetings, or VIP transport, we deliver smooth, reliable, and hassle-free mobility solutions. With professionally trained chauffeurs, flexible rental plans, GPS-enabled cabs, and dedicated corporate service support, Pune Corporate Cars India Private Limited ensures a trusted and superior travel experience for businesses operating in and around Sitapura Industrial Area.',

    top: 'Top Places to Visit in Jaipur with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Amber Fort",
    "description": "Amber Fort is one of Jaipur’s most iconic landmarks, known for its majestic hilltop location, grand gateways, courtyards, royal halls, and stunning blend of Rajput and Mughal architecture. Visitors can explore the Sheesh Mahal, Diwan-e-Aam, and the historic palace interiors while enjoying panoramic views of the surrounding hills and Maota Lake."
  },
  {
    "title": "City Palace",
    "description": "Located in the heart of Jaipur, City Palace is a beautiful royal complex featuring museums, courtyards, galleries, and historic buildings. Built by Maharaja Sawai Jai Singh II, the palace showcases traditional Rajasthani craftsmanship, royal artifacts, and architectural grandeur that reflects the luxury and culture of Jaipur’s royal lineage."
  },
  {
    "title": "Hawa Mahal",
    "description": "Also known as the Palace of Winds, Hawa Mahal is a five-story architectural wonder designed with 953 intricately carved windows that allowed royal women to observe city life without being seen. Its honeycomb facade and pink sandstone design make it one of Jaipur’s most recognizable and photographed monuments."
  },
  {
    "title": "Jantar Mantar",
    "description": "Jantar Mantar is a UNESCO World Heritage Site and one of the world’s most well-preserved astronomical observatories. Featuring large scientific instruments built for measuring celestial movements and time, it provides insights into the advanced astronomical knowledge of 18th-century India and the scientific vision of Maharaja Sawai Jai Singh II."
  },
  {
    "title": "Jal Mahal",
    "description": "Situated in the middle of Man Sagar Lake, Jal Mahal is a stunning palace known for its serene surroundings and unique architectural design, where most of the structure remains submerged underwater. Visitors can enjoy scenic views from the lakeside and capture beautiful photographs during sunrise and sunset."
  },
  {
    "title": "Nahargarh Fort",
    "description": "Perched on the Aravalli Hills, Nahargarh Fort offers stunning views of Jaipur city. Historically built for defensive purposes, the fort later became a popular retreat for royalty. It remains one of the best sunset-viewing points, featuring cafes, walkways, and walls that narrate stories of Jaipur’s royal past."
  },
  {
    "title": "Albert Hall Museum",
    "description": "Albert Hall Museum is Rajasthan’s oldest state museum, showcasing a vast collection of royal artifacts, paintings, sculptures, weaponry, textiles, and decorative arts. Built in Indo-Saracenic architectural style, the museum is beautifully illuminated at night and represents Rajasthan’s cultural and artistic heritage."
  },
  {
    "title": "Birla Mandir (Laxmi Narayan Temple)",
    "description": "Birla Mandir is a modern white marble temple dedicated to Lord Vishnu and Goddess Laxmi. Surrounded by landscaped gardens and beautifully carved walls, the temple offers a peaceful spiritual atmosphere and showcases exquisite sculptures representing mythological themes and traditional Indian craftsmanship."
  },
  {
    "title": "Chokhi Dhani",
    "description": "Chokhi Dhani is a cultural village resort that provides a traditional Rajasthani rural experience through folk dance performances, camel rides, local craft stalls, puppet shows, and authentic Rajasthani cuisine. It is a popular destination for families and tourists seeking to experience the state’s vibrant culture in one place."
  },
  {
    "title": "Moti Dungri Ganesh Temple",
    "description": "Moti Dungri Ganesh Temple is one of Jaipur’s most revered places of worship, dedicated to Lord Ganesha. Located atop a small hill, the temple attracts devotees throughout the year for its peaceful environment, spiritual significance, and traditional architectural features that make it an important religious landmark in the city."
  }
],


"services": [
  {
    "name": "Sitapura Industrial Cab Jaipur",
    "description": "Sitapura Industrial Cab Jaipur provides reliable, safe, and comfortable corporate cab services for employees working in Sitapura Industrial Area. With a fleet of sedans and SUVs, trained drivers, GPS tracking, and optimized routes, it ensures timely daily commutes for factory and industrial staff."
  },
  {
    "name": "Corporate Shuttle Sitapura",
    "description": "Corporate Shuttle Sitapura offers high-capacity shuttle services for companies in Sitapura Industrial Area. Featuring AC minibuses, multi-shift support, route optimization, and real-time tracking, it ensures efficient and organized transport for large workforce teams."
  },
  {
    "name": "Factory Staff Transport Sitapura Jaipur",
    "description": "Factory Staff Transport Sitapura Jaipur delivers structured transportation for factory workers, including pre-planned pick-ups, verified drivers, and multi-shift support. The service ensures safe and timely commuting for industrial employees."
  },
  {
    "name": "Employee Commute Sitapura",
    "description": "Employee Commute Sitapura provides daily pick-up and drop services for employees working in Sitapura Industrial Area. With real-time GPS monitoring, professional drivers, and shift-aligned scheduling, it ensures reliable and efficient commuting."
  },
  {
    "name": "Business Cab Sitapura Jaipur",
    "description": "Business Cab Sitapura Jaipur offers executive travel solutions for meetings, client visits, airport transfers, and inter-office trips. With modern sedans and SUVs, experienced chauffeurs, and priority dispatch, it ensures comfortable and professional corporate travel."
  },
  {
    "name": "Monthly Cab Sitapura Jaipur",
    "description": "Monthly Cab Sitapura Jaipur provides long-term, contract-based corporate transport solutions. The service includes dedicated vehicles, trained drivers, GPS tracking, and maintenance support to ensure uninterrupted and reliable employee commuting."
  },
  {
    "name": "Affordable Cab Sitapura",
    "description": "Affordable Cab Sitapura delivers cost-effective transportation solutions without compromising on safety, punctuality, or comfort. Ideal for SMEs and mid-sized companies, it provides optimized routes, clean vehicles, and professional drivers."
  },
  {
    "name": "Best Corporate Cab Sitapura",
    "description": "Best Corporate Cab Sitapura offers premium-grade travel services with top-quality vehicles, expert chauffeurs, and superior safety protocols. Designed for executives and senior staff, it ensures a smooth, professional, and comfortable commuting experience."
  },
  {
    "name": "Outstation Cab Sitapura Jaipur",
    "description": "Outstation Cab Sitapura Jaipur provides long-distance corporate travel for meetings, client visits, factory tours, and executive trips. Featuring comfortable sedans and SUVs, experienced chauffeurs, interstate permits, and live GPS tracking, it ensures safe and hassle-free outstation mobility."
  },
  {
    "name": "Sedan Cab Sitapura",
    "description": "Sedan Cab Sitapura offers executive sedans for manager commutes, airport transfers, business visits, and daily premium office travel. Vehicles are maintained to high standards, and trained drivers ensure safe, smooth, and comfortable rides."
  },
  {
    "name": "SUV Cab Sitapura",
    "description": "SUV Cab Sitapura provides spacious, comfortable, and high-performance SUVs for senior executives, team travel, outstation trips, and long-distance corporate drives. The service emphasizes comfort, safety, and reliability with professional chauffeurs and advanced monitoring."
  },
  {
    "name": "Staff Pickup Drop Sitapura Jaipur",
    "description": "Staff Pickup Drop Sitapura Jaipur delivers structured employee pick-up and drop services with shift-aligned scheduling, route optimization, GPS tracking, and professional drivers to ensure timely and safe daily commuting."
  },
  {
    "name": "Company Fleet Sitapura Jaipur",
    "description": "Company Fleet Sitapura Jaipur offers comprehensive fleet management solutions including sedans, SUVs, and shuttles, driver management, vehicle maintenance, compliance tracking, and route optimization for corporate and industrial clients."
  },
  {
    "name": "Employee Mobility Sitapura",
    "description": "Employee Mobility Sitapura provides tech-enabled, flexible commuting solutions with GPS tracking, multi-shift support, and reliable scheduling to ensure seamless transport of employees across Sitapura Industrial Area."
  },
  {
    "name": "Industrial Shuttle Sitapura",
    "description": "Industrial Shuttle Sitapura delivers organized shuttle services for daily workforce transportation, featuring optimized routes, multi-shift operations, GPS monitoring, and dedicated coordination for safe and efficient employee mobility."
  }
],

"tableData": [
  ["Sitapura Industrial Cab Jaipur", "Corporate Shuttle Sitapura"],
  ["Factory Staff Transport Sitapura Jaipur", "Employee Commute Sitapura"],
  ["Business Cab Sitapura Jaipur", "Monthly Cab Sitapura Jaipur"],
  ["Affordable Cab Sitapura", "Best Corporate Cab Sitapura"],
  ["Outstation Cab Sitapura Jaipur", "Sedan Cab Sitapura"],
  ["SUV Cab Sitapura", "Staff Pickup Drop Sitapura Jaipur"],
  ["Company Fleet Sitapura Jaipur", "Employee Mobility Sitapura"],
  ["Industrial Shuttle Sitapura", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Sitapura Industrial Area",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Sitapura Industrial Area, ensuring smooth and efficient transportation for employees and business executives across the industrial zone."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We provide punctual pickups and drop-offs across Sitapura Industrial Area, helping employees reach factories, offices, and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs ensure safe, courteous, and disciplined travel, offering a secure and comfortable commuting experience for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel in Sitapura Industrial Area."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible and tailored corporate cab rental plans to meet the commuting needs of companies and employees in Sitapura Industrial Area."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized regularly and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is streamlined through our easy booking system and reliable coordination, making employee transport hassle-free."
  }
]


















  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Sitapura Industrial Area?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies and offices in Sitapura Industrial Area.',
  },
  {
    question: 'What types of corporate transportation services are available in Sitapura Industrial Area?',
    answer: 'We provide employee transportation, industrial shuttle services, corporate pickups and drops, airport transfers, and full fleet management for corporate clients.',
  },
  {
    question: 'Do you support daily employee commute services in Sitapura Industrial Area?',
    answer: 'Yes, we offer structured daily commute services with optimized routes, timely pickups, and multi-shift support for employees.',
  },
  {
    question: 'How can companies book corporate cab services in Sitapura Industrial Area?',
    answer: 'Companies can book through our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Which vehicles are available for corporate cab services in Sitapura Industrial Area?',
    answer: 'We offer hatchbacks, sedans, SUVs, Innova Crysta, tempo travellers, luxury cars, and electric vehicles based on corporate requirements.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts in Sitapura Industrial Area?',
    answer: 'Yes, we provide monthly, quarterly, and annual corporate transportation contracts with flexible pricing and comprehensive fleet management.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features?',
    answer: 'All vehicles are GPS-enabled, regularly sanitized, and driven by trained and background-verified chauffeurs to ensure maximum safety.',
  },
  {
    question: 'Do you provide transportation for night shifts and rotational shifts in Sitapura Industrial Area?',
    answer: 'Absolutely. We provide reliable transport solutions for night shifts, early morning shifts, weekend operations, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vikram Mehta',
    feedback: 'Dependable corporate cab service for our Sitapura Industrial Area office. Vehicles are clean and drivers are professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Sharma',
    feedback: 'Excellent service for industrial commutes. Timely pickups and smooth rides ensure hassle-free transportation for employees.',
    rating: 5,
  },
];














































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Sitapura Industrial Area Jaipur",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-sitapura.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited provides corporate cab services in Sitapura Industrial Area, Jaipur, offering industrial cabs, corporate shuttles, factory staff transport, employee commute, business cabs, monthly corporate cabs, affordable and executive cabs, outstation trips, sedan & SUV corporate cabs, staff pickup & drop, company fleet management, employee mobility solutions, and industrial shuttle services.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-sitapura-industrial-area"
  }
};







  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Sitapura Industrial Area Jaipur | Employee & Industrial Transport</title>

  <meta
    name="description"
    content="Corporate cab services in Sitapura Industrial Area, Jaipur offering industrial cabs, corporate shuttles, factory staff transport, employee commute, business cabs, monthly corporate cabs, affordable and executive cabs, outstation trips, sedan & SUV corporate cabs, staff pickup & drop, company fleet management, employee mobility solutions, and industrial shuttle services."
  />

  <meta
    name="keywords"
    content="Sitapura Industrial Cab Jaipur, Corporate Shuttle Sitapura, Factory Staff Transport Sitapura Jaipur, Employee Commute Sitapura, Business Cab Sitapura Jaipur, Monthly Cab Sitapura Jaipur, Affordable Cab Sitapura, Best Corporate Cab Sitapura, Outstation Cab Sitapura Jaipur, Sedan Cab Sitapura, SUV Cab Sitapura, Staff Pickup Drop Sitapura Jaipur, Company Fleet Sitapura Jaipur, Employee Mobility Sitapura, Industrial Shuttle Sitapura"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/97.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinsitparaindustrialarea;